import { Heading, Paragraph } from "../../../atoms";
import { Box } from "../../../cores";

interface ISimpleDescription {
  heading: string;
  paragraph: string;
  isMobile: boolean;
  smallWidthDesktop?: boolean;
}
const SimpleDescription = ({
  heading,
  paragraph,
  isMobile,
  smallWidthDesktop = false,
}: ISimpleDescription) => {
  return (
    <Box
      sx={{
        width: smallWidthDesktop ? ["100%", null, null, "50%", "50%"] : "100%",
      }}
    >
      <Heading as={"h4"} variant={!isMobile ? "h5" : "h6"}>
        {heading}
      </Heading>
      <Paragraph sx={{ fontSize: ["xs", null, "16px", null, null] }}>
        {paragraph}
      </Paragraph>
    </Box>
  );
};

export default SimpleDescription;
